import { loadStripe } from '@stripe/stripe-js'

export const STRIPE_PUBLISHABLE_KEY =
  process.env.STRIPE_PUBLISHABLE_KEY ||
  'pk_test_51MUqLuLmC5yNPmDNICQgmylLqVQdnjzPkkAtIFggZje0fKZuhFCBKgKbbIaVSlXcSffFJFush09Dt99Gf29Hukkk00HYfxM8wP'

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)
